/**
 * Tables transferred in device-to-device P2P transfer (client-writable subset
 * of `USER_DATA_TABLES`; insertion order: parents
 * before children -> `habit` before its completions/reminders/attachments).
 *
 * Excludes `habit_version`. Version history is server-materialized (sealed by the
 * API write-path) and READ-ONLY on the client — it arrives via sync streams. The server
 * re-derives it upon receiving imported habits; transferring it would generate local
 * rows the client cannot upload. `habit_version` is also absent from `USER_DATA_TABLES`
 * (FK-RESTRICT, never guest CRUD), so transfer and sweep both exclude it.
 */
export const P2P_TRANSFER_TABLES = [
  "habit",
  "habit_completion",
  "habit_reminder",
  "attachment",
] as const;
